import { CatsApiService } from '../services/CatsApiService';
import { useService } from 'react-service-injector';

export function useApi(): CatsApiService {
  return useService(CatsApiService);
}
